import {
  ButtonSkeleton,
  TextSkeleton,
} from "@imi/ui/components/Skeleton/Skeleton.js";
import { productRepository } from "@src/core/engine/products/productRepository";
import {
  SubProduct,
  subProductTypeToProductType,
} from "@src/routes/projects/$projectId/selections/direct/helpers/subProduct";
import { assert } from "radashi";
import { use } from "react";
import { useParams } from "react-router";
import { SubProductCell } from "../../../components/SubProducts/SubProductCell";
import { SubProductsDialogContext } from "../contexts/SubProductsDialogContext";
import { BatchSelectionRow } from "../store/types";
import styles from "./BatchSubProductCell.module.css";

type BatchSubProductCellProps = {
  row: BatchSelectionRow;
  type: SubProduct;
};

export function BatchSubProductCell({ row, type }: BatchSubProductCellProps) {
  const { openDialog } = use(SubProductsDialogContext);
  const params = useParams<{ category: string }>();
  assert(params.category, "Category param is required");

  if (row.output.status === "loading") {
    return (
      <div className={styles.SkeletonContainer}>
        <TextSkeleton />
        <ButtonSkeleton size="sm" />
      </div>
    );
  }

  if (!row.output.suggestion?.subProducts[type]) return null;

  const subProductsOfType = row.output.suggestion.subProducts[type] ?? [];
  const selection = row.output?.subProductsSelection?.selectedIds ?? [];

  return (
    <SubProductCell
      onViewClick={() => {
        openDialog({ row, type });
      }}
      product={row.output.suggestion}
      selection={selection
        .filter((product) => product.type === subProductTypeToProductType(type))
        .map((item) => productRepository.getById(item))}
      totalCount={subProductsOfType.length}
      type={type}
    />
  );
}
